import '../assets/font/Inter-Bold-normal';
import '../assets/font/Inter-Light-normal';
import '../assets/font/Inter-Regular-normal';
import '../assets/font/Inter-Medium-normal';
import '../assets/font/Inter-SemiBold-normal';

export default {
  methods: {
    async addHeaderPDF(doc, x, y) {
      let text = '';

      doc.setFont('Inter-Regular');
      doc.setFontSize(6);
      text = 'Sítio do Periquito - Rodovia Perdões, Km 03, AMG';
      doc.text(110, y + 4, text);
      text = '1650, Zona Rural, Ribeirão Vermelho - MG';
      doc.text(110, y + 8, text);

      doc.setFont('Inter-SemiBold');
      text = 'Tel:';
      doc.text(110, y + 12, text);
      doc.setFont('Inter-Regular');
      text = '(35) 99250-5255';
      doc.text(114, y + 12, text);

      doc.setFont('Inter-SemiBold');
      text = 'E-mail:';
      doc.text(110, y + 16, text);
      doc.setFont('Inter-Regular');
      text = 'comercial@cogumelosumami.com.br';
      doc.text(117.5, y + 16, text);

      doc.setFont('Inter-SemiBold');
      text = 'Site:';
      doc.text(110, y + 20, text);
      doc.setFont('Inter-Regular');
      text = 'www.cogumelosumami.com.br';
      doc.text(115, y + 20, text);

      doc.setFont('Inter-SemiBold');
      text = 'Redes sociais:';
      doc.text(110, y + 24, text);
      doc.setFont('Inter-Regular');
      text = '@cogumelosumami';
      doc.text(125, y + 24, text);

      return doc;
    },
    async addTablePDF(doc, x, y, pedido, clientes) {
      const headStyles = {
        fontSize: 8, // Tamanho da fonte do cabeçalho
        fontStyle: 'bold', // Estilo da fonte do cabeçalho (negrito)
        fillColor: [255, 255, 255], // Cor de fundo do cabeçalho (branco)
        textColor: [0, 0, 0], // Cor do texto (preto)
        lineWidth: 0.4, // Espessura da borda
        lineColor: [0, 0, 0], // Cor da borda (cinza)
      };

      // // Defina um estilo para o corpo da tabela
      const bodyStyles = {
        fontSize: 8, // Tamanho da fonte do corpo da tabela
        textColor: [0, 0, 0], // Cor do texto (preto)
        lineWidth: 0.4, // Espessura da borda
        lineColor: [0, 0, 0], // Cor da borda (cinza)
        minCellHeight: 27, // Altura mínima da célula
      };

      doc.autoTable({
        head: [['CNPJ: 42.391.306/0001-66']],
        theme: 'plain',
        startY: y + 30,
        styles: { halign: 'center' },
        headStyles,
        tableWidth: 45,
        margin: { left: x },
      });

      doc.autoTable({
        head: [['Marco Antonio Junqueira']],
        theme: 'plain',
        startY: y + 30,
        styles: { halign: 'center' },
        headStyles,
        tableWidth: 50,
        margin: { left: x + 45 },
      });

      const lastY = doc.lastAutoTable.finalY;

      const clientInfo = [['CLIENTE:'], ['ENDEREÇO:'], ['CIDADE:']];
      doc.autoTable({
        head: [['']],
        body: clientInfo,
        theme: 'plain',
        startY: lastY,
        styles: { halign: 'left', valign: 'middle' },
        headStyles,
        bodyStyles: {
          fontSize: 8, // Tamanho da fonte do corpo da tabela
          fontStyle: 'bold', // Estilo da fonte do cabeçalho (negrito)
          textColor: [0, 0, 0], // Cor do texto (preto)
          lineWidth: 0.4, // Espessura da borda
          lineColor: [0, 0, 0], // Cor da borda (cinza)
          minCellHeight: 9,
          1: { minCellHeight: 9 },
        },
        tableWidth: 45,
        margin: { left: x },
      });

      const clienteid = pedido.client.id;
      const clientCity = clientes.find((cliente) => cliente.id === clienteid);

      const clientData = [
        [`${pedido.client.name.toUpperCase()}`],
        [
          `${pedido.client.street.toUpperCase()} ${
            pedido.client.houseAddressNumber
          }, ${pedido.client.neighborhood.toUpperCase()}`,
        ],
        [`${clientCity.city.name.toUpperCase()}`],
      ];

      const orderDate = pedido.buy_date
        .split('T')[0]
        .split('-')
        .reverse()
        .join('/');

      doc.autoTable({
        head: [[orderDate]],
        body: clientData,
        theme: 'plain',
        startY: lastY,
        styles: { halign: 'left', valign: 'middle' },
        headStyles: {
          ...headStyles,
          halign: 'center',
        },
        bodyStyles: {
          fontSize: 6, // Tamanho da fonte do corpo da tabela
          textColor: [0, 0, 0], // Cor do texto (preto)
          lineWidth: 0.4, // Espessura da borda
          lineColor: [0, 0, 0], // Cor da borda (cinza)
          minCellHeight: 9,
        },
        tableWidth: 50,
        margin: { left: x + 45 },
      });

      doc.autoTable({
        head: [['ASSINATURA DO CLIENTE']],
        body: [['']],
        theme: 'plain',
        startY: lastY,
        styles: { halign: 'center' },
        headStyles,
        bodyStyles,
        tableWidth: 55,
        margin: { left: x + 95 },
      });

      doc.autoTable({
        head: [['PEDIDO NÚMERO']],
        body: [[`${pedido.id}`]],
        theme: 'plain',
        startY: lastY,
        styles: { halign: 'center' },
        headStyles,
        bodyStyles: {
          ...bodyStyles,
          fontStyle: 'bold',
          valign: 'middle',
        },
        tableWidth: 40,
        margin: { left: x + 150 },
      });

      const columns = [
        'DESCRIÇÃO',
        'QUANTIDADE',
        'PREÇO UNIT.',
        'DESCONTO',
        'TOTAL',
      ];
      const rows = [];

      function formatUnidade(produto) {
        if (produto.quantity_kg > 0) {
          return ' (KG)';
        }
        if (produto.quantity_plate > 0) {
          return ' (BDJ)';
        }
        if (produto.quantity_unity > 0) {
          return ' (UNI)';
        }
        return ''; // Retorna uma string vazia se não houver quantidade
      }

      // Preenchendo as linhas da tabela com os dados do pedido
      pedido.order_products.sort();
      pedido.order_products.forEach((produto) => {
        const unidade = formatUnidade(produto);
        const totalProduto = produto.total_price;
        const quantidade = [];

        if (produto.quantity_kg > 0) {
          quantidade.push(`${produto.quantity_kg}`);
        }

        if (produto.quantity_plate > 0) {
          quantidade.push(`${produto.quantity_plate}`);
        }

        if (produto.quantity_unity > 0) {
          quantidade.push(`${produto.quantity_unity}`);
        }

        if (quantidade.length > 0) {
          rows.push([
            `${produto.type.toUpperCase()}${unidade}`,
            quantidade.join(', '), // Unir as quantidades em uma string separada por vírgula
            `R$ ${produto.price.toFixed(2)}`,
            `${produto.discount}%`,
            `R$ ${totalProduto.toFixed(2)}`,
          ]);
        }
      });

      doc.autoTable({
        head: [columns],
        body: rows,
        theme: 'plain',
        startY: doc.lastAutoTable.finalY,
        styles: { halign: 'center' },
        headStyles,
        bodyStyles: {
          ...bodyStyles,
          minCellHeight: 0,
        },
        tableWidth: 190,
        margin: { left: x },
        columnStyles: {
          0: { cellWidth: 67.5, halign: 'left' },
          1: { cellWidth: 27.5, halign: 'center' },
          2: { cellWidth: 27.5, halign: 'center' },
          3: { cellWidth: 27.5, halign: 'center' },
          4: { cellWidth: 40, halign: 'center' },
        },
      });

      const secondLastY = doc.lastAutoTable.finalY;

      doc.autoTable({
        head: [['TAXA DE ENTREGA']],
        theme: 'plain',
        startY: secondLastY,
        styles: { halign: 'left' },
        headStyles,
        tableWidth: 67.5,
        margin: { left: x },
      });

      doc.autoTable({
        head: [['']],
        theme: 'plain',
        startY: secondLastY,
        headStyles,
        tableWidth: 82.5,
        margin: { left: x + 67.5 },
      });

      doc.autoTable({
        head: [[`R$ ${pedido.delivery_tax.toFixed(2)}`]],
        theme: 'plain',
        startY: secondLastY,
        styles: { halign: 'center' },
        headStyles,
        tableWidth: 40,
        margin: { left: x + 150 },
      });

      const thirdLastY = doc.lastAutoTable.finalY;

      doc.autoTable({
        head: [['TOTAL GERAL']],
        theme: 'plain',
        startY: thirdLastY,
        styles: { halign: 'left' },
        headStyles,
        tableWidth: 67.5,
        margin: { left: x },
      });

      doc.autoTable({
        head: [['']],
        theme: 'plain',
        startY: thirdLastY,
        headStyles,
        tableWidth: 82.5,
        margin: { left: x + 67.5 },
      });

      doc.autoTable({
        head: [[`R$ ${pedido.total_price.toFixed(2)}`]],
        theme: 'plain',
        startY: thirdLastY,
        styles: { halign: 'center' },
        headStyles,
        tableWidth: 40,
        margin: { left: x + 150 },
      });

      const observations = `OBSERVAÇÔES: ${pedido.observation}`;

      doc.autoTable({
        head: [[observations]],
        theme: 'plain',
        startY: doc.lastAutoTable.finalY,
        styles: { halign: 'left' },
        tableWidth: 190,
        headStyles: {
          ...headStyles,
          minCellHeight: 10,
        },
        margin: { left: x },
      });
      return doc;
    },
  },
};
